import React from 'react';
import "../design/app.css";
import ChatRoom from './chatroom.js';
import {auth, useAuthState} from '../firebase.js';
import Nav from './Nav.js';
import PhoneVerification from './phoneVerify';

function App() {
  const [user] = useAuthState(auth);

  return (
    <div className="container">
      <Nav user={user}/>
      {user ? <ChatRoom/> : <PhoneVerification />}
      {/* {<PhoneVerification/>} */}
    </div>
  )
}

export default App
